/* eslint react-hooks/exhaustive-deps: "warn" */

import { useInt } from 'hooks/useInt';

import { Faq } from 'ui/atoms/Faq/Faq';
import { DeliveryTable } from 'ui/organisms/DeliveryTable/DeliveryTable';

import { DataLicensingRedistributionAiTraining } from 'landing-pages/data-licensing-redistribution/sections/DataLicensingRedistributionAiTraining/DataLicensingRedistributionAiTraining';
import { DataLicensingRedistributionClauses } from 'landing-pages/data-licensing-redistribution/sections/DataLicensingRedistributionClauses/DataLicensingRedistributionClauses';
import { DataLicensingRedistributionClose } from 'landing-pages/data-licensing-redistribution/sections/DataLicensingRedistributionClose/DataLicensingRedistributionClose';
import { DataLicensingRedistributionCompliance } from 'landing-pages/data-licensing-redistribution/sections/DataLicensingRedistributionCompliance/DataLicensingRedistributionCompliance';
import { DataLicensingRedistributionCoverage } from 'landing-pages/data-licensing-redistribution/sections/DataLicensingRedistributionCoverage/DataLicensingRedistributionCoverage';
import { DataLicensingRedistributionHero } from 'landing-pages/data-licensing-redistribution/sections/DataLicensingRedistributionHero/DataLicensingRedistributionHero';
import { DataLicensingRedistributionModels } from 'landing-pages/data-licensing-redistribution/sections/DataLicensingRedistributionModels/DataLicensingRedistributionModels';
import { DataLicensingRedistributionRights } from 'landing-pages/data-licensing-redistribution/sections/DataLicensingRedistributionRights/DataLicensingRedistributionRights';
import { DataLicensingRedistributionWhy } from 'landing-pages/data-licensing-redistribution/sections/DataLicensingRedistributionWhy/DataLicensingRedistributionWhy';

import styles from './DataLicensingRedistributionPage.module.scss';

import { getDeliveryRows, getFaqData } from './DataLicensingRedistributionPage.data';

export const DataLicensingRedistributionPage = () => {
  const { t } = useInt();

  return (
    <div className={styles.wrapper}>
      <DataLicensingRedistributionHero />
      <DataLicensingRedistributionClauses />
      <DataLicensingRedistributionRights />
      <DataLicensingRedistributionWhy />
      <DataLicensingRedistributionCoverage />
      <DeliveryTable
        title={t('Shipped the way your pipeline already expects it')}
        description={t('The licence decides what you may do with the data. Delivery decides how fast you can ship it.')}
        rows={getDeliveryRows(t)}
      />
      <DataLicensingRedistributionAiTraining />
      <DataLicensingRedistributionModels />
      <Faq title={t('The questions procurement asks first')} data={getFaqData(t)} />
      <DataLicensingRedistributionClose />
      <DataLicensingRedistributionCompliance />
    </div>
  );
};
